<template>
    <div>
        <div class="pd-5">
            <el-form>
                <el-form-item :label="$t('integration.belonging_to')">
                    {{ exDetail.fullPath }}
                </el-form-item>
                <el-form-item :label="$t('integration.monitoring_point')">
                    {{ exDetail.carrierName }}
                </el-form-item>
                <el-form-item :label="$t('integration.installation_point')">
                    {{ exDetail.carrierDeviceName }}
                </el-form-item>
                <el-form-item :label="$t('integration.type')">
                    {{ exType[exDetail.exCatalog] && $t(alarmReason[exDetail.exCatalog].title) }}
                </el-form-item>
                <el-form-item :label="$t('integration.abnormal_time')">
                    {{ $timetransition(exDetail.happenTime) }}
                </el-form-item>
                <el-form-item :label="$t('integration.state')">
                    {{ exDetail.status ? $t('integration.close') : $t('integration.not_closed') }}
                </el-form-item>
                <el-form-item :label="$t('integration.processing_results')">
                    {{ exDetail.processResult }}
                </el-form-item>
                <el-form-item :label="$t('integration.remarks')">
                    {{ exDetail.processRemark }}
                </el-form-item>
                <el-form-item :label="$t('integration.closing_time')">
                    {{ $timetransition(exDetail.closeTime) }}
                </el-form-item>
                <el-form-item :label="$t('integration.duration')">
                    {{ timeInterval(exDetail.happenTime, exDetail.closeTime) }}
                </el-form-item>
            </el-form>

            <div class="uk-position-relative">
                <el-tabs type="card" v-model="tab">
                    <el-tab-pane :label="$t('integration.abnormal_record')" name="ExRecord"></el-tab-pane>
                    <el-tab-pane :label="$t('integration.processing_records')" name="HandleRecord"></el-tab-pane>
                </el-tabs>
                <el-button class="btn-handle" type="primary" @click="handle">{{ $t('integration.handle') }}</el-button>
            </div>
            <div>
                <component :is="tab" :exId="exDetail.id" ref="records"></component>
            </div>
        </div>
        <HandleExDia :exId="exDetail.id"></HandleExDia>
    </div>
</template>
<script>
import bus from '@/utils/bus'
import ExRecord from './component/ExRecord.vue';
import HandleRecord from './component/HandleRecord.vue';
import HandleExDia from '@/pages/abnormal/component/HandleExDia/HandleExDia'
import { exDetail } from '@/api/modules/abnormal';
import { timeInterval } from "@/utils/time";
import {alarmReason} from '@/utils/convert'

export default {
    props: ['exDetail'],
    components: {
        ExRecord,
        HandleRecord,
        HandleExDia
    },
    data() {
        return {
            tab: 'ExRecord',
            alarmReason
        }
    },
    computed: {
        timeInterval: () => timeInterval,
        exType() {
            return this.$store.state.exType
        }
    },
    beforeDestroy() {
        bus.$off('exDetail');
    },
    methods: {
        handle() {
            bus.$emit('handleEx', {
                detail: [this.exDetail],
                callback: () => {
                    if (this.tab == 'HandleRecord') {
                        this.$refs['records'].getListFn()
                    }
                }
            });
        }
    }
}
</script>
<style scoped lang="scss">
::v-deep .el-tabs__item {
    padding: 0 13px !important;
}

.btn-handle {
    position: absolute;
    right: 0;
    top: 5px;
}
</style>
